import { Box, styled } from '@mui/material';

const Container = styled(Box)`
  width: 100%;
  display: flex;

  justify-content: end;
`;

export default Container;
